import { t as defaultT } from '@app/i18n';

export const DEFAULT_TELEHEALTH_PROVIDERS = [
  'Teladoc',
  'MdLive',
  'Amwell',
  'DoctorOnDemand',
  'LiveHealthOnline',
];

export const getDefaultCardList = (t = defaultT) => [
  {
    id: 1,
    telehealthProvider: 'Teladoc',
    telehealthLink: t(
      `telehealthScreen.telehealthProviders.Teladoc.telehealthLink`,
    ),
    description: t(`telehealthScreen.telehealthProviders.Teladoc.description`),
  },
  {
    id: 2,
    telehealthProvider: 'MdLive',
    telehealthLink: t(
      `telehealthScreen.telehealthProviders.MdLive.telehealthLink`,
    ),
    description: t(`telehealthScreen.telehealthProviders.MdLive.description`),
  },
  {
    id: 3,
    telehealthProvider: 'Amwell',
    telehealthLink: t(
      `telehealthScreen.telehealthProviders.Amwell.telehealthLink`,
    ),
    description: t(`telehealthScreen.telehealthProviders.Amwell.description`),
  },
  {
    id: 4,
    telehealthProvider: 'DoctorOnDemand',
    telehealthLink: t(
      `telehealthScreen.telehealthProviders.DoctorOnDemand.telehealthLink`,
    ),
    description: t(
      `telehealthScreen.telehealthProviders.DoctorOnDemand.description`,
    ),
  },
  {
    id: 5,
    telehealthProvider: 'LiveHealthOnline',
    telehealthLink: t(
      `telehealthScreen.telehealthProviders.LiveHealthOnline.telehealthLink`,
    ),
    description: t(
      `telehealthScreen.telehealthProviders.LiveHealthOnline.description`,
    ),
  },
];
